export default __webpack_public_path__ + "src/assets/icn-swap-flip.b4a4cc1a537037e3dc2cc216fd381871.svg";